import { render, staticRenderFns } from "./RadioFieldDialog.vue?vue&type=template&id=c20b2d2c&"
import script from "./RadioFieldDialog.vue?vue&type=script&lang=js&"
export * from "./RadioFieldDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports